import React from "react"
import PropTypes from "prop-types"
import ResStates from "./restrictedStates"

export class RestrictedStateWiseComponent extends React.Component {
	render () {
		const { children, regionName } = this.props
		if (ResStates.indexOf(regionName.toLowerCase()) >= 0) {
			return null
		} else return children
	}
}

RestrictedStateWiseComponent.propTypes = {
	children: PropTypes.node,
	regionName: PropTypes.string
}

export default RestrictedStateWiseComponent



// WEBPACK FOOTER //
// ./src/components/RestrictedStateWiseComponent.js